import './index.less';
import React, { useEffect, useState } from 'react';
// 引入子组件
import ComponyList from './componyList';
import ComSpaceList from './comSpaceList';
import MenuOptions from './menuOptions';

// 顶部导航Tabs组件
import { Tabs } from 'antd';

const ComponySet = () => {
  // 顶部导航Tabs相关
  const { TabPane } = Tabs;
  const onChange = (key: string) => {
    console.log(key);
  };

  return (
    <div>
      <div>
        <div className="web_head">公司管理</div>
        <div className="content_box">
          <Tabs defaultActiveKey="componyList" onChange={onChange}>
            <div className="gapBox"></div>
            <TabPane tab="公司列表" key="componyList">
              <ComponyList />
            </TabPane>
            <TabPane tab="企业空间列表" key="comSpaceList">
              <ComSpaceList />
            </TabPane>
            <TabPane tab="菜单配置" key="menuOptions">
              <MenuOptions />
            </TabPane>
          </Tabs>
        </div>
      </div>
    </div>
  );
};

export default ComponySet;
